import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { PromotionsPupop } from "./PromotionsPupop"
import { useGetPromotions } from "../../../hooks/Promotions/useGetPromotions"
import { promotionsMemory } from "../../../Objects/Memory/Memory"
import { Promotions } from "../../../Objects/Promotion/Promotions"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useTranslation } from "react-i18next"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const PromotionsPage: React.FC = () => {
  const { t } = useTranslation("list")

  const [enablePromotions, setEnablePromotions] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const { handleGetPromotions } = useGetPromotions()

  const [promotion, setPromotionSelected] = useState<Promotions | undefined>(undefined)

  useEffect(() => {
    handleGetPromotions(() => {})
  }, [])

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setEnablePromotions(status)

    setPromotionSelected(undefined)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  const handleOpenEditePromotion = (id: number) => {
    const promotion = promotionsMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setPromotionSelected(promotion)
  }

  const handleCopyPromotion = () => {
    if (!promotion) {
      return
    }

    setPromotionSelected(new Promotions({ ...promotion, id: -1 }))
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("label_promotions_page_message_count")}
          messageEmpty={t("label_promotions_page_message_empty")}
          nameFindSearch={t("label_promotions_page_place_holder")}
          data={promotionsMemory.getListCards(true)}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetPromotions(() => {})}
          handleOnClick={(e) => handleOpenEditePromotion(e)}
        />
      </div>

      {enablePromotions && (
        <PromotionsPupop
          promotions={promotion}
          title={promotion && promotion.id !== -1 ? t("promotion:title_popup_edite") : t("promotion:title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyPromotion}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="promocoes"
          title={t("dataImport:title", { target: t("dataImport:target_promotions") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetPromotions(() => {})}
        />
      )}
    </>
  )
}
